import { ICourseCatalogQuery } from '../interfaces/course-catalog.query.interface';
import { CourseCatalogCategory } from './course-catalog-category.model';

// @dynamic
export class CourseCatalog {
    id: string;
    experience: { id: string };
    visibleToUsers: boolean;
    currency: string;
    titleTranslations: {
        'translation_en-GB': string;
        'translation_de-DE': string;
        'translation_fr-FR': string;
        'translation_it-CH': string;
    };
    categories: CourseCatalogCategory[];

    constructor(query: ICourseCatalogQuery) {
        this.id = query.id.toString();
        this.experience = { id: query.experience.id.toString() };
        this.visibleToUsers = query.visible_to_users;
        this.currency = query.currency || null;
        this.titleTranslations = { ...query.title_translations };
        this.categories = query.categories?.length
            ? query.categories
                  .map((category) => new CourseCatalogCategory(category))
                  .sort((a, b) => a.sequence - b.sequence)
            : [];
    }
}
